import OppregAdminService from '@/services/oppregadmin.service.js'
import AccountInventoryService from '../../../../../services/accountinventory.service'
import ChangeLogService from '../../../../../services/changelog.service'
import ContactinfoService from '../../../../../services/contactinfo.service'
import DraftOpportunityService from '../../../../../services/draftopportunity.service.js'

export default {
  getChangeLogs: (context, id) => {
    context.commit('setLoadingLogs', true)
    OppregAdminService.getChangeLogsById(id, res => {
      context.commit('setChangeLogs', res)
      context.commit('setLogsShown', true)

      context.commit('setLoadingLogs', false)
    })
  },
  // Filter Oppreg Project Info WHERE Project_Id
  loadOppregProject: (context, projectId) => {
    context.commit('resetLoadWorkloadData')
    context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
    context.commit('setAwsStatus', false)
    
    OppregAdminService.getWorkloadsByProjectId(projectId, res => {
      context.commit('loadWorkloadData', res)
      context.commit('loadOppregProject', res)
      context.commit('setEmailButtonStatus', res)
      
      let obj = {
        Project_Id: res.questionaire.Project_Id,
        OppReg_Id: res.questionaire.OppReg_Id,
        Registration_Id: res.questionaire.Registration_Id,
        Contact_Id: res.questionaire.Contact_Id,
        SFDC_Id: res.questionaire.SFDC_Id,
        Workload_Title: res.questionaire.Workload_Title,
        Workload_type: res.questionaire.Workload_type,
        Projected_Monthly_Spend: res.questionaire.Projected_Monthly_Spend,
        Workload_Description: res.Workload_Description,
        AWSInfo_id: res.aws.AWSInfo_id,
        AWS_Approval: res.aws.AWS_Approval,
        AWS_Date_Approved: res.aws.AWS_Date_Approved,
        AWS_Notes: res.aws.AWS_Notes,
        AWS_SalesRep_Name: res.aws.AWS_SalesRep_Name,
        AWS_SalesRep_eMail: res.aws.AWS_SalesRep_eMail,
        OppReg_Status: res.aws.OppReg_Status
      }
      context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeFrom: obj }, { root: true })
      context.commit('setLoader', { loading: false }, { root: true })
      if (res.aws.AWSInfo_id) {
        let mergedAwsQuestionnaire = {
          Project_Id: res.questionaire.Project_Id,
          OppReg_Id: res.questionaire.OppReg_Id,
          Registration_Id: res.questionaire.Registration_Id,
          Contact_Id: res.questionaire.Contact_Id,
          SFDC_Id: res.questionaire.SFDC_Id,
          Workload_Title: res.questionaire.Workload_Title,
          Workload_type: res.questionaire.Workload_type,
          DXC_Managed_Services: res.questionaire.DXC_Managed_Services,
          Projected_Monthly_Spend: res.questionaire.Projected_Monthly_Spend,
          Workload_Description: res.Workload_Description,
          AWSInfo_id: res.aws.AWSInfo_id,
          AWS_Approval: res.aws.AWS_Approval,
          AWS_Date_Approved: res.aws.AWS_Date_Approved,
          AWS_Notes: res.aws.AWS_Notes,
          AWS_SalesRep_Name: res.aws.AWS_SalesRep_Name,
          AWS_SalesRep_eMail: res.aws.AWS_SalesRep_eMail,
          OppReg_Status: res.aws.OppReg_Status
        }
        context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeFrom: mergedAwsQuestionnaire }, { root: true })
        context.commit('setAwsStatus', true)
      }
    })
  },
  // Update Button for Opportunity Number
  // updateOppNumber: (context, workloadData) => {
  //   context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
  //   OppregAdminService.oppnumUpdate(workloadData, oppn => {
  //     context.commit('setLoader', { loading: false }, { root: true })
  //     alert('Opportunity Number has been successfully updated')
  //     context.commit('updateOppregAdminList', workloadData)
  //   })
  // },

  // checkIfOpportunityNumberIsAvailable: (context, id) => {
  //   context.commit('setOpportunityNumberExistLoading', true)
  //   console.log('Opportunity Number: ' + id)
  //   if ((id === null) || (id === '') || (id.toLowerCase() === 'none')) {
  //     context.commit('setOpportunityNumberExistLoading', false)
  //   } else {
  //     AccountInventoryService.checkIfOpportunityNumberIsAvailable(id, (res, err) => {
  //       if (err.opportunityNumberExist) {
  //         context.commit('setOpportunityNumberAvailabilityMessage', { type: 'error', isExist: true, message: 'This Opportunity Number has already been registered.', record: err.data[0] })
  //       } else {
  //         context.commit('setOpportunityNumberAvailabilityMessage', { type: 'success', isExist: false, message: 'This Opportunity Number is available to use.' })
  //       }
  //       context.commit('setOpportunityNumberExistLoading', false)
  //     })
  //   }
  // },
  // WORKLOAD SUBMIT
  submitAWSForm: (context, workloadData) => {
    context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
    ///////////////////////////////////////////////////////////////////////////////////
    //                    CODE TO UPDATE ONBOARDING REQUEST                          //    
    ///////////////////////////////////////////////////////////////////////////////////
    OppregAdminService.workloadSave(workloadData, awsInfoId => {
      // check if are we sending a notif about the update?
      if (workloadData.notifyWorkloadStatusUpdate) {
        OppregAdminService.sendChangeWorkloadNotification({
          id: workloadData.opportunity.Opportunity_Id,
          fromWorkloadType: context.state.newWorkload.oppproject.Workload_Status,
          toWorkloadType: workloadData.aws.OppReg_Status
        }, res => {
          console.log('email sent')
        })
      }

      if (workloadData.aws.OppReg_Status == 'Submitted to AWS') {
        console.log('Updating Draft Opportunity status to Submitted')
        // call Draft Opportunity API to update the status to submitted
        DraftOpportunityService.updateRecord(context.state.workload.questionaire.OppReg_Id, 'submitted', (res, err) => {
          if (err) {
            context.commit('setSnackbar', {
              show: true, type: 'error',
              timeout: 30000, message: err.message
              }, { root: true }
            )
          }
          console.log('Draft Opportunity status updated to Submitted')
        })

      }



      let acctType
      if(workloadData.aws.OppReg_Status === 'Approved - Tier 3 12%' 
          || workloadData.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA'
          || workloadData.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA SaaS'
          || workloadData.aws.OppReg_Status === 'Approved - Tier 2 - Custom EDP'
          || workloadData.aws.OppReg_Status === 'AWS Reg Accepted') {

            if (workloadData.workloadType) {
              acctType = workloadData.workloadType
            } else if(workloadData.aws.OppReg_Status === 'Approved - Tier 3 12%') {
              acctType = 'SPP'
            } else if (workloadData.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA' 
                        || workloadData.aws.Oppreg_Status === 'Approved - Tier 1 23% - PPA SaaS'){
              acctType = 'PPA'
            } else if (workloadData.aws.OppReg_Status === 'Approved - Tier 2 - Custom EDP'){
              acctType = 'EDP'
            }
            console.log('Current Account Type: ' +  acctType)


            OppregAdminService.getOnboardingRequest((res,err) => {
              if(err){
              } else {
                let onboardingData = res.filter(account => 
                    account.Registration_Id === workloadData.questionaire.Registration_Id        
                  )
                
              let onboardingDataa = onboardingData.filter((account) => {
                    if(account.Registration_Id === workloadData.questionaire.Registration_Id){
                      console.log('---2----')
                      console.log(account.Acct_name)
                      account.Acct_name = account.Acct_name.replace('TBD', acctType)
                      account.Onboarding_Status ='New'
                    }
                    return account
                  })
                OppregAdminService.updateOnboardingRequests(onboardingDataa, (res,err) => {})
              }
            }) //end onboarding request
          }
      console.log('updating draft opportunity status to submitted')
      console.log(workloadData.aws.OppReg_Status)
      
      context.commit('setLoader', { loading: false }, { root: true })
      context.commit('setAwsInfoId', awsInfoId)
      let aws = {
        OppReg_Id: context.state.workload.questionaire.OppReg_Id,
        Registration_Id: context.state.workload.questionaire.Registration_Id,
        Contact_Id: context.state.workload.questionaire.Contact_Id,
        SFDC_Id: context.state.workload.questionaire.SFDC_Id,
        Workload_Title: context.state.workload.questionaire.Workload_Title,
        Workload_type: context.state.workload.questionaire.Workload_type,
        Projected_Monthly_Spend: context.state.workload.questionaire.Projected_Monthly_Spend,
        Workload_Description: context.state.workload.questionaire.Workload_Description,
        AWSInfo_id: workloadData.aws.AWSInfo_id,
        AWS_Approval: workloadData.aws.AWS_Approval,
        AWS_Date_Approved: workloadData.aws.AWS_Date_Approved,
        AWS_Notes: workloadData.aws.AWS_Notes,
        AWS_SalesRep_Name: workloadData.aws.AWS_SalesRep_Name,
        AWS_SalesRep_eMail: workloadData.aws.AWS_SalesRep_eMail,
        OppReg_Status: workloadData.aws.OppReg_Status,
        Project_Id: vm.$route.params.id,
        Non_DXC_Account_No: workloadData.aws.Non_DXC_Account_No,
        Non_DXC_Launch_Date: workloadData.aws.Non_DXC_Launch_Date
      }
      let { Workload_Description, ...toOppregProjectData } = aws
      context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeTo: toOppregProjectData, module: 'oppreg' }, { root: true })
      ChangeLogService.create(context.rootState.logRecord)
      context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeFrom: toOppregProjectData }, { root: true })
      let test = {
        Project_Id: vm.$route.params.id,
        Workload_Status: workloadData.aws.OppReg_Status
      }
      context.commit('setAwsStatus', true)
      context.commit('setEmailButtonStatus')
      context.commit('setCurrentAwsInfo', workloadData.aws)
      context.commit('refreshMasterWorkloads', test)
      context.commit('updateOppregAdminList', workloadData)

     
    })
  },
  // REVIEW EMAIL TEMPLATE
  reviewEmailTemplate: (context, emailType) => {
    let awsEmailTemplate = {
      template: emailType,
      recipients: context.state.workload.contact.Contact_Email,
      oppreg_id: context.state.workload.questionaire.Registration_Id,
      oppreg_status: context.state.workload.aws.OppReg_Status,
      Workload_Status: context.state.workload.questionaire.Workload_Status,
      Workload_Title: context.state.workload.questionaire.Workload_Title,
      sales_rep_name: context.state.workload.aws.AWS_SalesRep_Name,
      sales_rep_email: context.state.workload.aws.AWS_SalesRep_eMail,
      note: context.state.dialogEmail.Notes,
      oppOwnerEmail: context.state.workload.opportunity.Owner_Email === 'None' ? '' : context.state.workload.opportunity.Owner_Email,
      oppOwnerName: context.state.workload.opportunity.Owner_Name === 'None' ? '' : context.state.workload.opportunity.Owner_Name,
      oppRegId: context.state.workload.opportunity.Opportunity_Id
    }

    context.commit('loadingEmail', true)
    AccountInventoryService.getEmailTemplate(awsEmailTemplate, res => {
      let emailContent = {
        templateEmail: res.content.body,
        emailSubjectType: res.content.subject,
        emailRecipients: [res.content.to]
      }
      context.commit('loadEmailTemplate', emailContent)
      context.commit('loadingEmail', false)
    })
  },
  // SEND EMAIL TEMPLATE
  sendEmailTemplate: (context, emailType) => {
    let sendAwsEmailTemp = {
      template: emailType,
      // recipients: context.state.dialogEmail.Contact_Email,
      recipients: context.state.dialogEmail.emailRecipients.join(','),
      oppreg_id: context.state.workload.questionaire.Registration_Id,
      oppreg_status: context.state.workload.aws.OppReg_Status,
      Workload_Title: context.state.workload.questionaire.Workload_Title,
      sales_rep_name: context.state.workload.aws.AWS_SalesRep_Name,
      sales_rep_email: context.state.workload.aws.AWS_SalesRep_eMail,
      note: context.state.dialogEmail.Notes,
      oppOwnerEmail: context.state.workload.opportunity.Owner_Email === 'None' ? '' : context.state.workload.opportunity.Owner_Email,
      oppOwnerName: context.state.workload.opportunity.Owner_Name === 'None' ? '' : context.state.workload.opportunity.Owner_Name,
      oppRegId: context.state.workload.opportunity.Opportunity_Id
    }
    if (context.state.dialogEmail.isSubjectChanged) {
      sendAwsEmailTemp['isSubjectChanged'] = context.state.dialogEmail.isSubjectChanged
      sendAwsEmailTemp['emailSubjectType'] = context.state.dialogEmail.emailSubjectType
    }

    if (context.state.dialogEmail.isTemplateChanged) {
      sendAwsEmailTemp['isTemplateChanged'] = context.state.dialogEmail.isTemplateChanged
      sendAwsEmailTemp['templateEmail'] = context.state.dialogEmail.templateEmail
    }
    console.log('sendAwsEmailTemp:', sendAwsEmailTemp)

    AccountInventoryService.postEmailTemplate(sendAwsEmailTemp, res => {
      context.commit('clearTemplates', res.content)
    })
  },

  // action to ADD TO AWS EXTRACT DATA
  addToExport: (context, workloadData) => {
    context.commit('addtoExport', workloadData)
  },
  // action to REMOVE TO AWS EXTRACT DATA
  removeToExport: (context, workloadData) => { 
    context.commit('removetoExport', workloadData)
  },
  awsExport: (context, workloadData) => {
    context.commit('clearAwsExport', workloadData)
  },
  // UPLOAD DOCUMENT
  uploadOppRegDoc: (context, uploadData) => {
    context.commit('setUploadingState', true)
    OppregAdminService.uploadDocument(uploadData, res => {
      context.commit('reloadDocuments', res)
      context.commit('reloadDocuments', res.reloadResponse)
      context.commit('setUploadDialogState')
      context.commit('setUploadingState', false)
      // context.commit('clearFileUpload')
      let docId = res.docResponse.id
      let uploaded = res.reloadResponse.filter(result => {
        return result.Doc_Id == docId
      })

      let mergedData = {
        OppReg_Id: context.state.workload.questionaire.OppReg_Id,
        Registration_Id: context.state.workload.questionaire.Registration_Id,
        Contact_Id: context.state.workload.questionaire.Contact_Id,
        SFDC_Id: context.state.workload.questionaire.SFDC_Id,
        Workload_Title: context.state.workload.questionaire.Workload_Title,
        Workload_type: context.state.workload.questionaire.Workload_type,
        DXC_Managed_Services: context.state.workload.questionaire.DXC_Managed_Services,
        Projected_Monthly_Spend: context.state.workload.questionaire.Projected_Monthly_Spend,
        Workload_Description: context.state.workload.questionaire.Workload_Description,
        AWSInfo_id: context.state.workload.aws.AWSInfo_id,
        AWS_Approval: context.state.workload.aws.AWS_Approval,
        AWS_Date_Approved: context.state.workload.aws.AWS_Date_Approved,
        AWS_Notes: context.state.workload.aws.AWS_Notes,
        AWS_SalesRep_Name: context.state.workload.aws.AWS_SalesRep_Name,
        AWS_SalesRep_eMail: context.state.workload.aws.AWS_SalesRep_eMail,
        OppReg_Status: context.state.workload.aws.OppReg_Status,
        Project_Id: vm.$route.params.id
      }
      let { Workload_Description, ...toOppregProjectData } = mergedData
      context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeFrom: null }, { root: true })
      context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeTo: uploaded[0] }, { root: true })
      ChangeLogService.create(context.rootState.logRecord)
      context.commit('setChangeLogRecord', { id: vm.$route.params.id, changeFrom: toOppregProjectData }, { root: true })
    })
  },

  downloadOppRegDoc: (context, object_key) => {
    OppregAdminService.downloadDocument(object_key, res => {
      window.open(res, '_blank')
    })
  },

  // GENERAL REPORTING
  getOppRegRequestData: (context, params) => {
    context.commit('setLoadingRequest', true)
    context.commit('resetNewOppRegistration')
    context.commit('showWorkloadSearching', { searching: true })
    OppregAdminService.retrieveOppRegRequests(params, (res, err) => {
      if (err) {
        // handle error
        if (err.noOpportunityFound) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 20000,
              message: err.message
            },
            { root: true }
          )
          context.commit('setNotification', { withError: true })
          context.commit('setWorkloadDataList', [])
          context.commit('setAdminReportNextPageKey', '')
        }
      } else {
        // console.log('NO WORKLOADS FOUND')
        if (res.noWorkloadsFound) {
          context.commit('setNotification', { withError: true })
          context.commit('setSnackbar',
            {
              show: true,
              type: 'info',
              timeout: 20000,
              message: res.message,
              buttons: false
            },
            { root: true }
          )
        } else {
          if (res.OppRegRequestsData.data_result && res.OppRegRequestsData.data_result.length > 0) {
            // context.commit('setWorkloadDataList', res.OppRegRequestsData)
            context.commit('setWorkloadDataList', res.OppRegRequestsData.data_result)
            context.commit('setAdminReportNextPageKey', res.OppRegRequestsData.next_key)
          } else {
            context.commit('setWorkloadDataList', [])
            context.commit('setAdminReportNextPageKey', '')
            context.commit('setNotification', { withError: true })
          }
        }
      }
      context.commit('setLoadingRequest', false)
      context.commit('showWorkloadSearching', { searching: false })
    })
  },

  // DOWNLOAD GENERAL REPORTING
  downloadOppRegRequestData: (context, params) => {
    context.commit('showWorkloadSearching', { inProgress: true })
    OppregAdminService.retrieveOppRegRequests(params, (res, err) => {
      window.open(res, '_blank')
      context.commit('showWorkloadSearching', { inProgress: false })
    })
  },

  reportOppRegRequestData: (context, params) => {
    context.commit('showWorkloadSearching', { reportInProgress: true })
    OppregAdminService.retrieveOppRegRequests(params, (res, err) => {
      window.open(res, '_blank')
      context.commit('showWorkloadSearching', { reportInProgress: false })
    })
  },

  submitToAPN: (context, workloadData) => {
    context.commit('setLoader', { loading: true, text: 'Uploading Opportunity data to APN...' }, { root: true })
    OppregAdminService.submitOpportunityDataToAPN(workloadData, (res, err) => {
      if (res) {
        context.commit('clearAwsExport', workloadData)
        context.commit('setSnackbar', {
          show: true,
          type: 'primary',
          timeout: 20000,
          message: res.data,
          buttons: false
        }, { root: true }
        )
      }
      context.commit('setLoader', { loading: false}, { root: true })
    })
  },

  updateQuestionnaire: (context, answers) => {
    context.commit('setLoader', { loading: true, text: 'Updating workload questionnaire answers...' }, { root: true })
    OppregAdminService.updateQuestionnaire(answers, (res, err) => {
      if (err) {
        context.commit('setSnackbar', {
          show: true,
          type: 'error',
          timeout: 20000,
          message: res.error,
          buttons: false
        }, { root: true })
      } else {
        context.commit('setWorkloadType', answers.type)
        context.commit('setSnackbar', {
          show: true,
          type: 'primary',
          timeout: 20000,
          message: 'Successfully update workload questionnaire answers',
          buttons: false
        }, { root: true })
      }
      context.commit('setLoader', {loading: false}, { root: true })
    })
  },

  updateContact: (context, contact) => {
    context.commit('setLoader', { loading: true, text: 'Validating Email Address...' }, { root: true })
    OppregAdminService.validateContactEmail(contact, (contactResponse, err) => {
      if (err) {
        // email not found,
        context.commit('setLoader', { text: 'Creating new Contact...' }, { root: true })
        let newContact = {
          Contact_First_Name: contact.Contact_First_Name,
          Contact_Last_Name: contact.Contact_Last_Name,
          Contact_Email: contact.Contact_Email,
          Contact_Phone: contact.Contact_Phone,
          Contact_Title: contact.Contact_Title
        }
        // create new contact
        ContactinfoService.create( newContact, (id, err) => {
          if (err) {
            context.commit('setSnackbar', {
                show: true,
                type: 'error',
                timeout: 5000,
                message: err.error,
                buttons: false
            }, { root: true })
          } else {
            OppregAdminService.updateProjectContact({ Registration_Id: context.state.newWorkload.oppproject.Registration_Id, Contact_Id: id }, (projectResponse, err) => {
              if (err) {
                context.commit('setSnackbar', {
                  show: true,
                  type: 'error',
                  timeout: 5000,
                  message: err.error,
                  buttons: false
                }, { root: true })
              } else {
                context.commit('setSnackbar', {
                  show: true,
                  type: 'primary',
                  timeout: 5000,
                  message: 'Successfully Updated Contact Details',
                  buttons: false
                }, { root: true })
              }
              context.commit('setLoader', {loading: false}, { root: true })
              context.commit('updateContactInfo', {...newContact, Id: id })
            })
          }
        })
      } else {
        if (contactResponse.Id !== contact.Id) {
          context.commit('showDialog', {
            show: true,
            type: 'confirmation',
            persistent: true,
            title: 'This contact email already exist. Would you like to use the existing contact?',
            yesLabel: 'Yes',
            noLabel: 'No',
            yesHandler: () => {
              context.commit('setLoader', { loading: true, text: 'Updating Contact Details...' }, { root: true })
              OppregAdminService.updateProjectContact({ Registration_Id: context.state.newWorkload.oppproject.Registration_Id, Contact_Id: contactResponse.Id }, (projectResponse, err) => {
                if (err) {
                  context.commit('setSnackbar', {
                    show: true,
                    type: 'error',
                    timeout: 5000,
                    message: res.error,
                    buttons: false
                  }, { root: true })
                } else {
                  context.commit('setSnackbar', {
                    show: true,
                    type: 'primary',
                    timeout: 5000,
                    message: 'Successfully Updated Contact Details',
                    buttons: false
                  }, { root: true })
                }
                context.commit('setLoader', {loading: false}, { root: true })
                context.commit('updateContactInfo', contactResponse)
                context.commit('showDialog', { show: false }, { root: true })
              })
            },
            noHandler: () => {
              context.commit('showDialog', { show: false }, { root: true })
            }
          }, { root: true })
        } else {
          context.commit('setLoader', { loading: true, text: 'Updating Contact Info' }, { root: true })
          OppregAdminService.updateContact(contact, (res, err) => {
            if (err) {
              context.commit('setSnackbar', {
                show: true,
                type: 'error',
                timeout: 5000,
                message: res.error,
                buttons: false
              }, { root: true })
            } else {
              context.commit('setSnackbar', {
                show: true,
                type: 'primary',
                timeout: 5000,
                message: 'Successfully Updated Contact Details',
                buttons: false
              }, { root: true })
            }
            context.commit('setLoader', {loading: false}, { root: true })
            context.commit('updateContactInfo', contact)
          })
        }
      }
      context.commit('setLoader', {loading: false}, { root: true })
    })
  },

  updateOpportunity: (context, opportunity) => {
    console.log('updating opportunity')
    console.log(opportunity)
    context.commit('setLoader', { loading: true, text: 'Updating Opportunity...' }, { root: true })
    OppregAdminService.updateOpportunity(opportunity, (oppResponse, err) => {
      if (err) {
        context.commit('setLoader', { loading: true, text: 'Updating Opportunity...' }, { root: true })
      } else {
        context.commit('updateOpportunityInfo', opportunity)
      }
      context.commit('setLoader', { loading: false }, { root: true })
    })
  },

  updateAccount: (context, account) => {
    console.log('updateAccount', context, account)
    context.commit('setLoader', { loading: true, text: 'Updating Account...' }, { root: true })
    OppregAdminService.updateAccount(account, (oppResponse, err) => {
      if (err) {
        context.commit('setLoader', { loading: true, text: 'Updating Account...' }, { root: true })
      } else {
        context.commit('updateAccount', account)
      }
      context.commit('setLoader', { loading: false }, { root: true })
    })
  },
  getListArchive: async (context, params) => {
    context.commit('setLoadingData', true)
    context.commit('clearAdminWorkloadList')
    let workloads = []
    if (params.isList) {
      workloads = await OppregAdminService.getArchive(params)
      context.commit('setNextArchivedPageKey', workloads.nextPageKey)
      context.commit('clearAdminNextPageKey')
    } else {
      workloads = await OppregAdminService.listAdminOppreg(params)
      context.commit('setAdminNextPageKey', workloads.nextPageKey)
      context.commit('clearNextArchivedPageKey')
    }
    context.commit('setAdminWorkloadList', workloads.data)
    context.commit('setLoadingData', false)
  },
  archiveOppregData: async (context, params) => {
    let update = await OppregAdminService.archiveOppreg(params)
    console.log('workloads', update)
  },
  refreshData: async (context) => {
    context.commit('setLoader', { loading: true, text: 'Loading' }, { root: true })
    let update = await OppregAdminService.refreshData()
    context.commit('setInitData', update.oppreg_data)
    context.commit('setLoader', { loading: false }, { root: true })
    console.log('workloads', update)
  },
  getOppRegAdminListData: async (context, params) => {
    context.commit('setLoadingData', true)
    console.log('getOppRegAdminListData>>>>>>>>>>>>>', vm.$store.state['admin/oppregAdmin'].adminWorkloadList.length)
    // if (!vm.$store.state['admin/oppregAdmin'].adminWorkloadList) {
    //   context.commit('clearAdminWorkloadList')
    //   context.commit('clearAdminNextPageKey')
    // }
    let workloads = await OppregAdminService.listAdminOppreg(params)
    context.commit('setAdminWorkloadList', workloads.data)
    context.commit('setAdminNextPageKey', workloads.nextPageKey)
    context.commit('setLoadingData', false)
  },
  refreshOppRegAdminListData: async (context, params) => {
    console.log('refreshOppRegAdminListData')
    context.commit('clearAdminWorkloadList')
    context.commit('clearAdminNextPageKey')
  },
  clearAdminWorkloadList: (context) => {
    context.commit('clearAdminWorkloadList')
  },
  clearAdminReportWorkloadList: (context) => {
    context.commit('clearAdminReportWorkloadList')
  }
}
